/*
 * Copyright © 2020-2023 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: yongqiang
 * @LastEditTime: 2024-01-04 21:37:58
 */
import React, { useMemo, useEffect } from 'react'
import { Modal } from 'antd'
import sensors from '../../../../utils/sensors'
import { folderDetailPath } from '../../../../utils/aiFolderClassify'
import { useAppSelector, useSensorsRole } from '../../../../app/hooks'
import StatusSuccessImg from '../../../../images/uploadPhotos/status-success.png'
import StatusErrorImg from '../../../../images/uploadPhotos/status-error.png'

const Status = ({ fileList, onClose, folderID, currentIndex }) => {
  const groupID = useAppSelector((state) => state.group.groupId)
  const role = useSensorsRole()

  const successNum = useMemo(() => {
    return currentIndex + 1
  }, [currentIndex])

  const failedNum = useMemo(() => {
    return fileList.length - successNum
  }, [fileList, successNum])

  const allFailed = useMemo(() => {
    return successNum === 0
  }, [successNum])

  const sensorsEvent = (actionType) => {
    sensors.track('web_get_action_bigbatch_upload_complete', {
      actionType,
      groupID,
      role
    })
  }

  const handleCheckPhotoClick = () => {
    sensorsEvent('clickView')
    window.location.href = folderDetailPath(folderID)
  }

  const handleModalClose = () => {
    sensorsEvent('clickClose')
    onClose()
  }

  useEffect(() => sensorsEvent('showPop'), [])

  return (
    <Modal
      open
      getContainer={false}
      wrapClassName="status-modal"
      width={780}
      style={{ height: '540px' }}
      mask={{ closable: false }}
      footer={null}
      onCancel={handleModalClose}
    >
      {allFailed ? (
        <h3>批量上传失败</h3>
      ) : failedNum > 0 ? (
        <h3>
          批量上传完成，成功{successNum}张，失败{failedNum}张
        </h3>
      ) : (
        <h3>批量上传完成，成功{fileList.length}张</h3>
      )}
      {allFailed ? (
        <>
          <img src={StatusErrorImg} alt="" />
          <button className="cancel-btn" onClick={onClose}>
            我知道了
          </button>
        </>
      ) : (
        <>
          <img src={StatusSuccessImg} alt="" />
          <button className="check-photo-btn" onClick={handleCheckPhotoClick}>
            查看照片
          </button>

          <p className="tip">
            可前往<strong>“分类文件夹&gt;上传的照片/视频”</strong>
            查看批量上传的照片
          </p>
        </>
      )}
    </Modal>
  )
}

export default Status
